module.exports = __webpack_public_path__ + "static/img/page2.6bdf937.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/page2.jpg
// module id = zyi2
// module chunks = 1